import React, { useEffect, useState, useRef } from "react";
import api from "../../services/api";
import { Navigate, useLocation, useNavigate } from "react-router";
import { debounce } from "../../utils/Debounce";
import { useFormik, validateYupSchema } from "formik";
import Select from "react-select";
import * as Yup from "yup";
import Modal from "react-bootstrap/Modal";
import { Toast } from "../../shared/Toast";
import {
  bannerOptions,
  dfpBackfillAdTypes,
  roles,
  updateBlockerFlag,
  magazineCreativeOptions,
  magazineCreatives,
  classifiedCreatives,
  classifiedCreativeOptions,
  recadCreatives,
  DESIGN_OPTIONS,
  FULLSCRTYPE_OPTIONS
} from "../../utils/constants";
import { isExpired } from "../../utils/dateFormat";
import {
  daysBetween,
  NEWISODateString,
  SameDay,
  formatDateWithTime,
  DatetoTimestamp,
  End_date_cpd,
} from "../../utils/dateFormat";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";
import PreviewFrameEdit from "../PreviewFrameEdit";
import Stepper from "react-stepper-horizontal";
import { SlButton } from "@shoelace-style/shoelace/dist/react";
import config from "../../config.js";

export const campCreativeContext4 = React.createContext();

const actiontypeoptions = ["Shuffle", "Round robin"];

function CreativeSelection() {
  const steps = [
    { title: "LineItem" },
    { title: "Targets" },
    { title: "Dates & Budget" },
    { title: "Creative Selection" },
  ];

  const navigate = useNavigate();
  const location = useLocation();
  const [checker, setchecker] = useState(true);
  const [tempcpd, setTempcpd] = useState(0);
  const [discountMessage, setDiscountMessage] = useState("");
  const [localHeadsList, setLocalHeadsList] = useState([]);
  const [discoutnEnab, setDiscountEnab] = useState(false);
  const [descReason,setdescReason] = useState(false);
  const [priceFetchLoading, setPriceFetchLoading] = useState(false);
  let type = location.state.type;
  const isBrandAd = location.state.isBrandAd;
  const isClassified  = location.state.isClassified;

  const typeofcamp = location.state.start.campaign_type;
  let order = location.state.order;

  const defaultValue = (options, value) => {
    return options ? options.find((option) => option.value === value) : "";
  };
  const [crelist, setcrelist] = useState([]);

  useEffect(() => {
    if (localStorage.getItem("role") !== roles.ops) navigate("/pagenotfound");
    if (location.state?.creatselect) editaction();
    else if(location?.state?.prefillingData?.creatselect) prefilling()
  }, []);

  const [campName, setCampName] = useState("");
  const [smShow, setSmShow] = useState(false);
  const [checkbox, setCheckbox] = useState(false);
  const [priceErr, setPriceErr] = useState(false);
  const [ptype, setPtype] = useState("");
  const [initialCPDFlag, setInitialCPDFlag] = useState(true);

  const editaction = async () => {
    let creatselect = location.state.creatselect;
    if((isClassified && !classifiedCreatives.includes(creatselect.creative_type)) || (isBrandAd && !(magazineCreatives.includes(creatselect.creative_type) || creatselect.creative_type === "brandAd")) || (!isClassified && !isBrandAd && classifiedCreatives.concat(magazineCreatives).includes(creatselect.creative_type))){
      creatselect.creative_type = ""
    }
    await formik.setFieldValue("creative_type", creatselect.creative_type);
    await formik.setFieldValue(
      "webview_creative_type",
      creatselect.webview_creative_type || ""
    );
    // formik.setFieldValue("encryption", creatselect.encryption);
    if(creatselect?.description)
    {
      formik.setFieldValue("description",creatselect.description);
    }
    if(creatselect?.fileUrl)
    { 
      formik.setFieldValue("fileUrl",creatselect.fileUrl);
    }
    formik.setFieldValue("is_backfill",+creatselect.is_backfill)
    formik.setFieldValue("dfp_hidden", creatselect.dfp_hidden);
    formik.setFieldValue("dfp_ima", creatselect.dfp_ima);
    formik.setFieldValue("dfp_ima_obs", creatselect.dfp_ima_obs);
    formik.setFieldValue("dfp_pgdeal", creatselect.dfp_pgdeal);
    formik.setFieldValue("ad_reach", creatselect.ad_reach);
    formik.setFieldValue('share_ad', creatselect.share_ad);
    formik.setFieldValue("dir_serve", creatselect.dir_serve || false);
    formik.setFieldValue("dir_prmry_serv", creatselect.dir_prmry_serv || false);
    formik.setFieldValue("position", creatselect.position);
    formik.setFieldValue("positiontype", creatselect.positiontype);
    formik.setFieldValue("frequency_cap", creatselect.frequency_cap);
    formik.setFieldValue("ad_code", creatselect.ad_code);
    formik.setFieldValue("design_type", creatselect.design_type || 0);
    formik.setFieldValue("full_scr_type", creatselect.full_scr_type || 0);
    formik.setFieldValue(
      "dfp_backfill_ad_type",
      creatselect.dfp_backfill_ad_type
    );
    formik.setFieldValue("slotuuid", creatselect.slotuuid);
    formik.setFieldValue("banner_size", creatselect.banner_size);
    formik.setFieldValue("frequency_cap_type", creatselect.frequency_cap_type);
    creatselect.line_item_code === null
      ? formik.setFieldValue("line_item_code", "")
      : formik.setFieldValue("line_item_code", creatselect.line_item_code);
    creatselect.dfp_creative_ids === null
      ? formik.setFieldValue("dfp_creative_ids", "")
      : formik.setFieldValue("dfp_creative_ids", creatselect.dfp_creative_ids);
    creatselect.post_type === null
      ? formik.setFieldValue("post_type", "")
      : formik.setFieldValue("post_type", creatselect.post_type);
    creatselect.news_type === null
      ? formik.setFieldValue("news_type", "")
      : formik.setFieldValue("news_type", creatselect.news_type);
    formik.setFieldValue("priority", +creatselect.priority);
    if (creatselect.action_type !== null)
      formik.setFieldValue("action_type", creatselect.action_type.toString());
    if (typeofcamp === "CPD") {
      formik.setFieldValue("cpd", creatselect.cpd);
      formik.values.cpd = creatselect.cpd;
    } else formik.setFieldValue("cpd", 0);
    formik.setFieldValue("sov", creatselect.sov);
    const creativeType =
    creatselect.creative_type !== "webviewad"
      ? creatselect.creative_type
      : creatselect.webview_creative_type;

    if ((!isBrandAd) && type !== "DFP" && !isClassified) {
      if (creatselect.sov) {
        handleLocal("sov", creativeType);
      } else if (+creatselect.position >= 0) {
        handleLocal(creatselect.position, creativeType);
      }
    }
    if (
      (isBrandAd || creatselect.creative_type === 'commentad') &&
      creatselect.brand_post_ids.length
    ) {
      formik.setFieldValue("brand_post_ids", creatselect.brand_post_ids);
      if(creatselect.creative_type !== 'commentad')
        await brandAdsPreview(creatselect.brand_post_ids);
    }
  };
  const prefilling = async () => {
    const creatselect = location.state.prefillingData.creatselect;
    await formik.setFieldValue("creative_type", creatselect.creative_type);
    formik.setFieldValue("position", creatselect.sov ? 0 :creatselect.position);
    if (typeofcamp === "CPD") {
      formik.setFieldValue("cpd", creatselect.cpd);
      formik.values.cpd = creatselect.cpd;
    } else formik.setFieldValue("cpd", 0);
    formik.setFieldValue("sov", creatselect.sov);
    if( !isBrandAd &&
      type !== "DFP"){
        handleLocal(
          creatselect.sov ? 'sov' : creatselect.position,
          creatselect.creative_type !== "webviewad"
            ? creatselect.creative_type
            : creatselect.webview_creative_type
        );
      }
  };


  const getcrelist = async () => {
    try {
      let res = await api({
        url: "/getcrelist",
        method: "GET",
        responseType: "json",
      });
      setcrelist(res.data);
    } catch (error) {
      if (error.response.status === 401) navigate("/");
    }
  };

  const [fct, Setfct] = useState(0);
  const check = (check) => {
    if (isBrandAd) {
      if (check === "creative_ids") return Yup.array().when("creative_type", {
        is: (value) => [...magazineCreatives, ...classifiedCreatives].includes(value),
        then: Yup.array().required("Creative Required").min(1, "Select atleast one creative"),
        otherwise: Yup.array(),
      });
    }
    if (type === "DFP" && check === "ad_code")
      return Yup.string().required("DFP code is required").matches(/^\/\d+\/[A-Za-z0-9]+_\d+$/, "Invalid DFP code format");
    if (type === "DFP" && check === "line_code")
      return Yup.string().required("Line Item Code is required");
    if (type === "DFP" && check === "dfp_creative_ids")
      return Yup.string()
        .required("DFP creative ids required")
        .matches(
          /^\s*\d{12}\s*(,\s*\d{12}\s*)*$/,
          "Enter comma seperated 12 digit Creative Ids"
        );
    if (type === "DFP" && check === "post_type")
      return Yup.string().required("Post Type is required");
    if (type === "DFP" && check === "news_type" && ptype === "video_webview_ad")
      return Yup.string().required("News Type is required");
    // else if ((typeofcamp === "CPD") && (check === "cpd"))
    //   return Yup.number().required("CPD Price is required").min(0, 'CPD price is required')
    // else if ((typeofcamp !== "CPD") && (check === "cpd"))
    //   return Yup.number()
    else if (check === "frequency_cap_type" && fct > 0)
      return Yup.string().required("Frequency Cap Type is required");
    else if (check === "frequency_cap_type" && fct === 0) return Yup.string();
    else if (check === "positiontype" && type !== "DFP")
      return Yup.string().required("Position type is required");
    else if (check === "creative_ids" && type !== "DFP")
      return Yup.array().min(1, "Select atleast one creative");
    else if (check === "creative_ids" && type === "DFP") return Yup.array();
    else return Yup.string();
  };

  const formik = useFormik({
    initialValues: {
      creative_type: "",
      creative_ids: [],
      position: "",
      positiontype: "fixed",
      frequency_cap: 0,
      ad_code: "",
      line_item_code: "",
      frequency_cap_type: "",
      action_type: "0",
      cpd: 0,
      post_type: "",
      news_type: "",
      encryption: true,
      dfp_hidden: false,
      dfp_ima: false,
      dfp_pgdeal:false,
      dfp_ima_obs: false,
      ad_reach:false,
      is_backfill: order?.backfill || 0,
      share_ad:false,
      dir_serve:false,
      dir_prmry_serv:false,
      dfp_creative_ids: "",
      priority: 1,
      brand_post_ids: "",
      dfp_backfill_ad_type: "",
      slotuuid: "",
      banner_size: [],
      design_type: 0,
      full_scr_type: 0,
      webview_creative_type: "",
      sov: false,
      fileUrl:'',
      description:"",
    },
    validationSchema: Yup.object({
      creative_type: check("creative_type"),
      creative_ids: check("creative_ids"),
      position: Yup.number().when("creative_type", {
        is: (creative_type) => !magazineCreatives.includes(creative_type),
        then: Yup.number()
          .required("Position is Required")
          .min(0, "Value should be greater than or equal to '0'"),
        otherwise: Yup.number().when("brand_post_ids", {
          is: (brand_post_ids) => !brand_post_ids,
          then: Yup.number()
            .required("Position is Required")
            .min(0, "Value should be greater than or equal to '0'"),
          otherwise: Yup.number().nullable().min(0, "Value should be greater than or equal to '0'"),
        }),
      }),
      positiontype: check("positiontype"),
      frequency_cap: Yup.number().min(
        0,
        "Frequency Cap Should Be Greater Than 0"
      ),
      ad_code: check("ad_code"),
      frequency_cap_type: check("frequency_cap_type"),
      action_type: Yup.string().required("Select the action type"),
      packages: Yup.string(),
      cpd:
        typeofcamp === "CPD"
          ? discoutnEnab || isBrandAd
            ? Yup.number()
                .required("CPD Price is required")
                .min(0, "CPD price should be greater than or equal to 0")
            : Yup.number()
                .required("CPD Price is required")
                .min(1, "CPD Price is required")
          : Yup.number(),
      line_item_code: check("line_code"),
      post_type: check("post_type"),
      news_type: check("news_type"),
      encryption: Yup.boolean(),
      dfp_hidden: Yup.boolean(),
      dfp_ima: Yup.boolean(),
      dfp_ima_obs: Yup.boolean(),
      dfp_pgdeal:Yup.boolean(),
      ad_reach: Yup.boolean(),
      dir_serve: Yup.boolean(),
      dir_prmry_serv: Yup.boolean(),
      share_ad: Yup.boolean().nullable(),
      dfp_creative_ids: check("dfp_creative_ids"),
      priority: Yup.number().required("Priority is required"),
      brand_post_ids: Yup.string().when('creative_type', {
        is: (value) => magazineCreatives.includes(value),
        then: Yup.string().when('position', {
          is: (value) => !value,
          then: Yup.string()
            .required("Post Ids required")
            .matches(/^\s*\d+\s*(,\s*\d+\s*)*$/, "Enter comma separated Post Ids"),
          otherwise: Yup.string().notRequired(),
        }),
        otherwise: Yup.string().when('creative_type', {
          is: (value) => value === 'brandAd',
          then: Yup.string()
            .required("Post Ids required")
            .matches(/^\s*\d+\s*(,\s*\d+\s*)*$/, "Enter comma separated Post Ids"),
          otherwise: Yup.string().notRequired(),
        }),
      }),      
      dfp_backfill_ad_type: Yup.string(),
      slotuuid: Yup.string().when("dfp_backfill_ad_type", {
        is: (value) =>
          value === "dfp_gm_amz" ||
          value === "dfp_gm_amz_nmb" ||
          value === "dfp_gm_amz_nmb1",
        then: Yup.string().required("Slot Id is Required"),
        otherwise: Yup.string(),
      }),
      banner_size: Yup.array().when("dfp_backfill_ad_type", {
        is: (value) =>
          value === "dfp_gm_nmb" ||
          value === "dfp_gm_amz" ||
          value === "dfp_gm_amz_nmb" ||
          value === "dfp_gm_amz_nmb1",
        then: Yup.array()
          .min(1, "Banner Size is Required")
          .required("Banner Size is Required"),
        otherwise: Yup.array(),
      }),
      design_type: Yup.number().when("dfp_backfill_ad_type", {
        is: (value) => value, 
        then: Yup.number().min(0, "Design Type is Required").required("Design Type is Required"),
        otherwise: Yup.number(),
      }),
      full_scr_type: Yup.number().when("design_type", {
        is: (value) => value === 5,
        then: Yup.number().min(1, "Full Screen Type is Required").required("Full Screen Type is Required"),
        otherwise: Yup.number(),
      }),
      webview_creative_type:
        typeofcamp === "CPD"
          ? Yup.string().when("creative_type", {
              is: (value) => value === "webviewad",
              then: Yup.string().required("Webview Creative Type is Required"),
              otherwise: Yup.string(),
            })
          : Yup.string(),
      sov: Yup.boolean(),
      ...(descReason
        ? {
            fileUrl: Yup.string()
            .matches(
              /^https?:\/\/.+/,
              { message: "Must be a valid HTTP or HTTPS URL", excludeEmptyString: true }
            ),
            description: Yup.string(),
          }
        : {}),

    }),
    onSubmit: async (values) => {
      if (priceErr && typeofcamp === "CPD") {
        Toast("error", priceErr);
        return;
      }
      if(+location?.state?.target?.app > 1000 && values.creative_type !== 'commentad'){
        Toast("error", "Please select non comment ad categories in target page");
        return;
      }
      if (
        typeofcamp === "CPD" &&
        +tempcpd !== +values.cpd &&
        discoutnEnab &&
        +tempcpd - +formik.values.cpd > 0
      ) {
        values.discount_obj = {
          discount_no: Math.abs(
            (100 / tempcpd) * (tempcpd - formik.values.cpd)
          ).toFixed(2),
          actualPrice: tempcpd,
          discountPrice: values.cpd,
          discsign: tempcpd - +formik.values.cpd > 0 ? false : true,
          typeofcamp,
        };
      }
      if (
        typeofcamp === "CPM" &&
        +location.state.budget.cpm !== +config.ACTUALCPM &&
        +config.ACTUALCPM - +location.state.budget.cpm > 0
      ) {
        values.discount_obj = {
          discount_no: Math.abs(
            (100 / config.ACTUALCPM) *
              (config.ACTUALCPM - +location.state.budget.cpm)
          ).toFixed(2),
          actualPrice: config.ACTUALCPM,
          discountPrice: +location.state.budget.cpm,
          discsign:
            config.ACTUALCPM - +location.state.budget.cpm > 0 ? false : true,
          typeofcamp,
        };
      }
      if (
        typeofcamp === "CPC" &&
        +location.state.budget.cpc_price !== +config.ACTUALCPC &&
        +config.ACTUALCPC - +location.state.budget.cpc_price > 0
      ) {
        values.discount_obj = {
          discount_no: Math.abs(
            (100 / config.ACTUALCPC) *
              (config.ACTUALCPC - +location.state.budget.cpc_price)
          ).toFixed(2),
          actualPrice: config.ACTUALCPC,
          discountPrice: +location.state.budget.cpc_price,
          discsign:
            config.ACTUALCPC - +location.state.budget.cpc_price > 0
              ? false
              : true,
          typeofcamp,
        };
      }
      if (isBrandAd || values.creative_type === 'commentad') {
        values.brand_post_ids = values.brand_post_ids ? values.brand_post_ids.split(",").map(Number) : [];
        values.company_id = order.company_id;
        values.position = values.position ? values.position : 0
        delete values.discount_obj;
      } else delete values.brand_post_ids;
      if(recadCreatives.includes(values.creative_type)){
         values.brand_post_ids = [];
      }
      if (values.creative_type === "webviewad") {
        if (typeofcamp !== "CPD") delete values.webview_creative_type;
      }
      if(!values.creative_type === 'webviewad')
          values.dir_serve = false
      if(type === 'DFP' || isBrandAd)
          values.dir_prmry_serv = false
      values.dir_prmry_serv = values.dir_prmry_serv ? 1 : 0
      if(!values.design_type)
          values.design_type = null
      if(!values.full_scr_type)
          values.full_scr_type = null
      // if (typeofcamp === "CPD" && order.order_id) {
      //   try {
      //     let req_data = { order_id: order.order_id }
      //     if (location?.state?.action === 'edit') {
      //       req_data.campaign_id = location?.state?.id
      //     }
      //     let res = await api({
      //       url: '/order/getOrdervalue',
      //       method: 'POST',
      //       responseType: 'json',
      //       data: req_data
      //     })
      //     if (res.code === 200) {
      //       if ((res?.data.total - res?.data.spent) <= 0) {
      //         Toast('error', `RO balance is  ${res.data.total - res.data.spent}`)
      //         return
      //       }
      //       if ((values.cpd + res.data.spent) > res.data.total) {
      //         Toast('error', `RO balance is  ${res.data.total - res.data.spent}`)
      //         return
      //       }
      //     }
      //     else {
      //       return
      //     }

      //   } catch (error) {
      //     console.error(error);
      //     if (error.response.status === 401)
      //       navigate("/")
      //   }
      // }

      switch (type) {
        case "Editorial":
          values.ad_code = "";
          values.post_type = "";
          values.news_type = "";
          values.line_item_code = "";
          values.dfp_creative_ids = "";
          break;
        case "Local":
          values.ad_code = "";
          values.post_type = "";
          values.news_type = "";
          values.line_item_code = "";
          values.dfp_creative_ids = "";
          break;
        default:
          values.creative_type = "";
          values.creative_ids = [];
          values.positiontype = "";
          // values.cpd = 0
          values.frequency_cap = 0;
          values.frequency_cap_type = "";
      }
      if (typeofcamp !== "CPD") {
        values.cpd = 0;
      }
      if(classifiedCreatives.includes(values.creative_type)){
        values.position = 9
      }

      const res = { ...values, position: parseInt(formik.values.position) };
      const result = { ...location.state, creatselect: res };
      if (true) {
        if (values.positiontype === "fixed" || type === "DFP") {
          values.frequency_cap = 0;
          values.frequency_cap_type = "";
          values.action_type = null;
        }
        if (type === "DFP" && values.post_type === "full_img_ad") {
          values.news_type = "image_ad";
        }
        values.banner_size = values.banner_size ? values.banner_size?.join(",") : '';
        const data1 = location.state;
        // delete data1.start.brand_type
        const { fileUrl, description, ...restValues } = values;
        const data = {
          action: data1.action,
          type: data1.type,
          ...data1.start,
          ...data1.budget,
          ...data1.date,
          ...restValues,
          prepaid: location.state.prepaid,
          sameday: location.state.sameday,
          plusdisable: location.state.plusdisable,
          order_id: order.order_id,
          share_ad:values.share_ad ? values.share_ad : false,
          descReason,
          ...(descReason
            ? {
              fileUrl,
              description
              }
            : {}),
        };
        const ID = data1.id;

        if (data.action === "add") {
          try {
            let res = await api({
              url: "/lineitems/create",
              method: "POST",
              responseType: "json",
              data: data,
            });
            let tarResult = {
              ...data1.target,
              campaign_id: res.data.rows[0].campaign_id,
            };
            // if (data1.type !== 'DFP') {
            try {
              let res1 = await api({
                url: "/user/target/postTarget",
                method: "POST",
                responseType: "json",
                data: tarResult,
              });
              if (res1?.code === 200 && res.code === 200) {
                Toast("success", "Inserted Successfully");
                navigate(`/home/order/${order.id}`, { state: { order } });
              } else {
                if (res1.code !== 200) {
                  let er = res1?.message || "Targets insert failed";
                  Toast("error", er);
                } else {
                  let er = res?.message || "Something went wrong";
                  Toast("error", er);
                }
              }
            } catch (error) {
              let er = error?.response?.message || "Something went wrong";
              Toast("error", er);
              if (error.response.status === 401) navigate("/");
            }
          } catch (error) {
            let er = error?.response?.message || "Something went wrong";
            Toast("error", er);
            console.error(error);
            if (error.response.status === 401) navigate("/");
          }
        }

        if (data.action === "edit") {
          const result = data;
          try {
            let editResult = {
              ...data1.target,
              target_id: location.state.target.target_id,
              campaign_id: location.state.id,
            };
            let res1 = await api({
              url: `/user/target/editTarget`,
              method: "PUT",
              responseType: "json",
              data: editResult,
            });
            let res = await api({
              url: `/lineitems/edit`,
              method: "PUT",
              responseType: "json",
              data: {
                result,
                ID,
              },
            });
            if (res1?.code === 200 && res.code === 200) {
              Toast("success", "Updated Successfully");
              navigate(`/home/order/${order.id}`, { state: { order } });
            } else {
              if (res1?.data?.code !== 200) {
                let er = res1?.data?.message || "Something went wrong"; // different format because (throwing Api Error)
                Toast("error", er);
              } else {
                let er = res?.data?.message || "Something went wrong"; // different format because (throwing Api Error)
                Toast("error", er);
              }
              navigate(`/home/lineitems`);
            }
          } catch (err) {
            console.error(err);
          }
        }
      }
    },
  });
  const handleFileChange = async (event) => {
    const file = event.currentTarget.files[0];
  
    if (!file) return;
  
    // if (file.type !== "application/pdf") {
    //   Toast("error", "Only PDF is allowed!");
    //   formik.setFieldValue("fileUrl", "");
    //   event.target.value = "";
    //   return;
    // }
  
  
    const formData = new FormData();
    formData.append("files", file);
  
    try {
      const res = await api({
        url: "/upload/file-upload-any",
        method: "POST",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
  
      if (res.code === 200) {
        formik.setFieldValue("fileUrl", res.data?.data);
        Toast("success", "File uploaded successfully");
      } else {
        Toast("error", res.message || "Upload failed");
      }
    } catch (error) {
      console.error(error);
      Toast("error", "Something went wrong during upload");
    }
  };
  
  const getCreatives = async () => {
    if (formik.values.creative_type !== "") {
      try {
        let res = await api({
          url: `/lineitems/creatives`,
          method: "POST",
          responseType: "json",
          data: {
            company_id: order.company_id,
            subtype: formik.values.creative_type,
          },
        });
        setcrelist(res.data);
        if (checker) {
          let arr = [];
          let crearr = [];
          res.data.map((item) => {
            crearr.push(item.value);
          });
          location.state.creatselect.creative_ids.map((x) => {
            if (crearr.includes(x)) {
              arr.push({ value: parseInt(x) });
            }
          });
          onchange(arr);
          setchecker(false);
        } else {
          formik.setFieldValue("creative_ids", []);
        }
      } catch (error) {}
    }
  };

  useEffect(() => {
    formik.setFieldValue("creative_ids", []);
    // setdescReason(false);
    // formik.setFieldValue("description",'');
    // formik.setFieldValue("fileUrl",'');
    getCreatives();
  }, [formik.values.creative_type]);

  const getvalues = (Array) => {
    return Array
      ? Array.filter(
          (option) => formik.values.creative_ids.indexOf(option.value) >= 0
        )
      : [];
  };

  const onchange = (selected) => {
    if (formik.values.creative_type !== "full_image") {
      let length = selected.length;
      formik.setFieldValue(
        "creative_ids",
        selected.length ? [selected[length - 1].value] : []
      );
    } else
      formik.setFieldValue(
        "creative_ids",
        selected ? selected.map((item) => item.value) : []
      );
  };
  const onBannerChange = (selected) => {
    let length = selected.length;
    if (
      formik.values.dfp_backfill_ad_type === "dfp_gm_nmb" ||
      formik.values.dfp_backfill_ad_type === "dfp_gm_amz" ||
      formik.values.dfp_backfill_ad_type === "dfp_gm_amz_nmb" ||
      formik.values.dfp_backfill_ad_type === "dfp_gm_amz_nmb1"
    ) {
      selected = selected.filter((item) => item.value !== "native");
      formik.setFieldValue(
        "banner_size",
        selected.length ? [selected[length - 1].value] : []
      );
    } else {
      formik.setFieldValue(
        "banner_size",
        selected ? selected.map((item) => item.value) : []
      );
    }
  };

  const handleGet = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await api({
          url: "/user/target/getposition",
          method: "POST",
          responseType: "json",
          data: {
            pos: formik.values.position,
            data: location.state.target,
            start_date:
              location.state.date.start_date || location.state.budget.start,
            end_date: location.state.date.end_date,
            id: location.state.id,
            position_type: formik.values.positiontype,
            campaign_name: location.state.start.campaign_name,
            dfp: location.state.dfp,
            creative_type: formik.values.creative_type,
            priority: formik.values.priority,
          },
        });
        if (res.code === 200) {
          if (res.data.length !== 0) {
            setCampName(res.data);
            setTimeout(() => setSmShow(true), 0);
            return resolve(res.data.campaign_name);
          } else {
            setTimeout(() => setSmShow(true), 0);
            setCampName("None");
            return resolve("None");
          }
        }
        if (res.status === 400) {
          setCampName(res.data?.message);
          setTimeout(() => setSmShow(true), 0);
          return resolve(res.message);
        }
      } catch (err) {
        console.error(err);
      }
    });
  };
  const back = () => {
    let creatselect_preview = { ...formik.values, creatives_preview };
    formik.values.positiontype === "rotation" &&
    formik.values.action_type !== null
      ? (creatselect_preview.action_type =
          actiontypeoptions[formik.values.action_type])
      : (creatselect_preview.action_type = null);
    let discount_obj = null;
    if (
      typeofcamp === "CPD" &&
      +tempcpd !== +formik.values.cpd &&
      discoutnEnab
    ) {
      discount_obj = {
        discount_no: Math.abs(
          (100 / tempcpd) * (tempcpd - formik.values.cpd)
        ).toFixed(2),
        actualPrice: tempcpd,
        discountPrice: formik.values.cpd,
        discsign: tempcpd - +formik.values.cpd > 0 ? false : true,
      };
    }
    if (formik.values.dfp_backfill_ad_type)
      creatselect_preview.dfp_backfill_ad_type = dfpBackfillAdTypes.find(
        (item) => item.value === formik.values.dfp_backfill_ad_type
      )?.lable;
    navigate("/home/campaign/date", {
      state: {
        ...location.state,
        creatselect: { ...formik.values },
        creatselect_preview: creatselect_preview,
        discount_obj,
      },
    });
  };
  const handleLocal = async (event, creative_type) => {
    if (typeofcamp === "CPD") {
      const total_budget = +location.state.budget.cpd;
      let res;
      if (event === "") {
        formik.setFieldValue("cpd", 0);
        setTempcpd(0);
        return;
      }
      if (!creative_type) {
        formik.setFieldTouched("creative_type", true);
        formik.setFieldTouched("webview_creative_type", true);
        formik.setFieldValue("position", 0);
        formik.setFieldValue("cpd", 0);
        return;
      }
      try {
        formik.setFieldValue("cpd", 0);
        setPriceFetchLoading(true);
        res = await api({
          url: `/user/target/getPrice`,
          method: "POST",
          responseType: "json",
          data: {
            state_ids: location.state.target.state_ids,
            district_ids: location.state.target.district_ids,
            mandal_ids: location.state.target.mandal_ids,
            village_ids: location.state.target.village_ids,
            position: event,
            lang_ids: location.state.target.lang_ids,
            exclude: location.state.target.exclude,
            constituency_ids: location.state.target.constituency_ids,
            creative_type: creative_type,
            zone_ids: location.state?.target?.zone_ids || [],
            order_id: order.order_id
          },
        });
        setPriceFetchLoading(false);
        if (res?.code !== 200) {
          setPriceErr(res.data.message || "Selected Location has no price.");
          Toast("error", res.data.message);
          formik.setFieldValue("cpd", 0);
          formik.values.cpd = 0;
          setTempcpd(0);
          setdescReason(false);
          return;
        }

        if (res.data === -1) {
          setPriceErr("Selected Location has no price.");
          formik.setFieldValue("cpd", 0);
          formik.values.cpd = 0;
          setTempcpd(0);
          setdescReason(false);
        } else {
          setPriceErr("");
          setTempcpd(res.data?.price);
          setdescReason(res.data?.reason);
          if (
            initialCPDFlag &&
            +location?.state?.creatselect?.cpd !== +res.data?.price
            //  || location?.state?.prefillingData?.creatselect?.cpd !== +res.data
          ) {
            formik.setFieldValue("cpd", location?.state?.creatselect?.cpd
              //  || location?.state?.prefillingData?.creatselect?.cpd
              );
            formik.values.cpd = location.state?.creatselect?.cpd
            //  || location?.state?.prefillingData?.creatselect?.cpd;
            setInitialCPDFlag(false);
            setDiscountEnab(true);
          } else {
            if(location?.state?.creatselect?.actual_running_cpd && location?.state?.status === 2 && location?.state?.creatselect?.actual_running_creative_type !== creative_type){
              formik.setFieldValue("cpd", location?.state?.creatselect?.actual_running_cpd);
              formik.values.cpd = location?.state?.creatselect?.actual_running_cpd;
              setdescReason(true);
              setDiscountEnab(true);
            }
            else{
            formik.setFieldValue("cpd", res.data?.price);
            formik.values.cpd = res.data?.price;
            }
            setInitialCPDFlag(false);
          }
        }
      } catch (e) {
        console.error(e);
      }
    }
  };

  // Create debounced version of handleLocal using useRef
  const debouncedHandleLocalRef = useRef();
  
  useEffect(() => {
    debouncedHandleLocalRef.current = debounce((value, creativeType) => {
      handleLocal(value, creativeType);
    }, 2000);
    
    // Cleanup function to clear the debounced function
    return () => {
      if (debouncedHandleLocalRef.current) {
        debouncedHandleLocalRef.current.cancel?.();
      }
    };
  }, [typeofcamp, location.state.budget.cpd]);
  
  const debouncedHandleLocal = (value, creativeType) => {
    if (debouncedHandleLocalRef.current) {
      debouncedHandleLocalRef.current(value, creativeType);
    }
  };

  // const DiscountHandler = async () => {
  //   if (!formik.errors.discount && formik.values.discount !== "") {
  //     try {
  //       let res = await api({
  //         url: `/user/campaign_creation/discountcalc`,
  //         method: "POST",
  //         responseType: "json",
  //         data: {
  //           discount: formik.values.discount ? formik.values.discount : location.state.creatselect.discount,
  //           company: location.state.start.company
  //         }
  //       })
  //       if (formik.values.packages === "1") {
  //         if (!res?.data[0]?.package || res.data.length === 0) {
  //           Toast('error', 'Please Enter valid Package Code')
  //           setDiscountError(true)
  //           setFreeCamp(false)
  //           return
  //         }
  //         if (isExpired(res?.data[0]?.start_date, res?.data[0]?.end_date)) {
  //           Toast('error', 'The Provided Code may expired or not valid please enter another valid code')
  //           setDiscountError(true)
  //           setFreeCamp(false)
  //           return
  //         }
  //         else {
  //           try {
  //             let request_data = { code: formik.values.discount }
  //             if(location.state.action === "edit")
  //               request_data.campaign_id = location.state.id
  //             let res1 = await api({
  //               url: `/user/campaign_creation/countcampcode`,
  //               method: "POST",
  //               responseType: "json",
  //               data: request_data
  //             })
  //             if (res1?.code === 200) {
  //               if(parseInt(res1?.data[0]?.count) < +res.data[0]?.paid_campaigns + +res.data[0]?.free_campaigns){
  //                 Toast('success', 'Package Code Applied')
  //                 setFreeCamp(false)
  //               }
  //               else{
  //                 Toast('error', 'Package code reached its limit')
  //                 setDiscountError(true)
  //                 setFreeCamp(false)
  //                 return
  //               }
  //               if(parseInt(res1?.data[0]?.count) < +res.data[0]?.paid_campaigns){
  //                 setDiscountMessage(`Remaining Paid Campaigns - ${+res.data[0]?.paid_campaigns - (parseInt(res1?.data[0]?.count) +1)} and Free Campaigns - ${+res.data[0]?.free_campaigns}`)
  //               }
  //               if (parseInt(res1?.data[0]?.count) >= res.data[0]?.paid_campaigns && (parseInt(res1?.data[0]?.count) < +res.data[0]?.paid_campaigns + +res.data[0]?.free_campaigns)) {
  //                 setFreeCamp(true)
  //                 Toast('success', 'This Campaign Run in Free Zone')
  //                 setDiscountMessage(`Remaining Paid Campaigns - 0 and Free Campaigns - ${+res.data[0]?.paid_campaigns + +res.data[0]?.free_campaigns - (parseInt(res1?.data[0]?.count) +1)}`)
  //                 formik.values.payment_status = 2;
  //               }
  //             }
  //             setDiscountError(false)
  //           }
  //           catch (err) {
  //             console.error(err)
  //           }
  //         }
  //       }
  //       if (formik.values.packages === "0") {
  //         if (res?.data[0]?.package || res.data.length === 0) {
  //           Toast('error', 'Please Enter valid Discount Code')
  //           setDiscountError(true)
  //           setDiscountMessage('')
  //           return
  //         }
  //         else {
  //           let request_data = { code: formik.values.discount }
  //           if(location.state.action === "edit")
  //             request_data.campaign_id = location.state.id
  //           let res1 = await api({
  //             url: `/user/campaign_creation/countcampcode`,
  //             method: "POST",
  //             responseType: "json",
  //             data: request_data
  //           })
  //           if (res1?.code === 200){
  //             if(parseInt(res1?.data[0]?.count) > 0){
  //               Toast('error', 'Discount Code Already Redeemed')
  //               setDiscountError(true)
  //               return
  //             }
  //           }
  //           let cpdprice = formik.values.cpd;
  //           let k = parseFloat(res.data[0].discount / 100) * cpdprice
  //           formik.setFieldValue('cpd',formik.values.discsign ? parseFloat(cpdprice + k): parseFloat(cpdprice - k))
  //           setDiscountMessage(`Actual CPD - ${cpdprice}. Dicount percentage - ${res.data[0].discount}%. After discount CPD - ${formik.values.discsign ? parseFloat(cpdprice + k): parseFloat(cpdprice - k)}. `)
  //           setDisableBtn(true)
  //           setDiscountError(false)
  //         }
  //       }
  //     }
  //     catch (err) {
  //       console.error(err)
  //     }
  //   }
  // }
  const getLocalheads = async () => {
    try {
      let res = await api({
        url: "/user/sales_persons/getLocalHeads",
        method: "GET",
        responseType: "json",
      });
      setLocalHeadsList([{ label: "None", value: 0 }, ...res.data]);
    } catch (error) {
      console.error("Error @ getLocalheads \n", error);
    }
  };
  const [creatives_preview, setCreatives_preview] = useState([]);

  const getCreative_Preview_data = async (ids) => {
    try {
      let res = await api({
        url: "/lineitems/creative_preview_data",
        method: "POST",
        responseType: "json",
        data: ids,
      });
      setCreatives_preview(res.data);
    } catch (error) {
      if (error.response.status === 401) navigate("/");
    }
  };
  const DFP_full_image_creative_preview = async (
    line_item_code,
    dfp_creative_ids
  ) => {
    try {
      let res = await api({
        url: "/lineitems/DFP_full_image_creative_preview",
        method: "POST",
        responseType: "json",
        data: {
          linecode: line_item_code,
          dfp_creative_ids,
        },
      });
      setCreatives_preview(res.data);
    } catch (error) {
      if (error.response.status === 401) navigate("/");
    }
  };

  useEffect(() => {
    if (
      formik.values.creative_ids.length &&
      formik.values.creative_type !== 'brandAd'
    )
      getCreative_Preview_data(formik.values.creative_ids);
    if(magazineCreatives.includes(formik.values.creative_type) && formik.values.brand_post_ids){
      brandAdsPreview(formik.values.brand_post_ids)
    }
  }, [formik.values.creative_ids]);
  useEffect(() => {
    if (
      formik.values.line_item_code.length >= 10 &&
      formik.values.line_item_code.length <= 15 &&
      formik.values.dfp_creative_ids.match(/^\s*\d{12}\s*(,\s*\d{12}\s*)*$/)
    )
      DFP_full_image_creative_preview(
        formik.values.line_item_code,
        formik.values.dfp_creative_ids
      );
  }, [formik.values.line_item_code, formik.values.dfp_creative_ids]);
  useEffect(() => {
    if (
      formik.values.creative_type === "commentad" ||
      formik.values.creative_type === 'brandAd' || classifiedCreatives.includes(formik.values.creative_type)
    ) {
      formik.setFieldValue("position", 1);
      formik.setFieldValue("positiontype", "fixed");
    }
    if(classifiedCreatives.includes(formik.values.creative_type)){
      handleLocal("1", formik.values.creative_type)
    }
    else if(!initialCPDFlag){
      handleLocal(formik.values.position || "", formik.values.creative_type)
    }
  }, [formik.values.creative_type]);
  // useEffect(()=>{
  //   getLocalheads()
  // },[])

  const fun = (id, list) => {
    for (let i = 0; i < list.length; i++) {
      if (list[i].value === id) {
        return list[i].label;
      }
    }
    return "-";
  };

  const brandAdsPreview = async (post_ids_string) => {
    try {
      let post_ids = post_ids_string.split(",").map(Number);
      const res = await api({
        url: "lineitems/post_idsPreview",
        method: "POST",
        responseType: "json",
        data: { post_ids, creative_ids: formik.values.creative_ids },
      });
      setCreatives_preview(res.data);
    } catch (error) {
      console.error("Error @ brandAdsPreview", error);
    }
  };

  return (
    <>
      <div className="campaign-drawer">
        <div className="title">
          <legend>Create LineItem</legend>
          <sl-icon
            name="x"
            type="button"
            className="text-danger mt-2"
            style={{ right: 20, position: "absolute" }}
            onClick={async () => {
              if (
                location.state.action === "edit" &&
                (location.state?.status === 5 || location?.state?.status === 2)
              ) {
                updateBlockerFlag(location.state.id, false);
              }
              navigate(`/home/order/${order.id}`, { state: { order } });
            }}
          ></sl-icon>
        </div>
        <div className={window.innerWidth <= 767 ? "" : "grid  grid-cols-2 divide-x mt-3"}>
          <div className="mobHide">
            <section className="flex gap-6">
              <div className="basis-7/12 grid gap-6 grid-cols-2">
                {location.state.start_preview && (
                  <section className="bg-slate-50 py-4 px-6 rounded-lg">
                    <h6 className="mb-2">LineItem Creation</h6>
                    {location.state.start_preview.campaign_name && (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">
                          LineItem Name :{" "}
                        </label>
                        <span>
                          {location.state.start_preview.campaign_name}
                        </span>
                      </div>
                    )}
                    {location.state.start_preview.campaign_type && (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">
                          LineItem Type :{" "}
                        </label>
                        <span>
                          {location.state.start_preview.campaign_type}
                        </span>
                      </div>
                    )}
                    {location.state.start_preview.campaign_type && (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">Type : </label>
                        <span>{location.state.type}</span>
                      </div>
                    )}
                    {location.state.start_preview.brand && (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">Brand : </label>
                        <span>{location.state.start_preview.brand_id}</span>
                      </div>
                    )}
                  </section>
                )}
                {location.state.target_preview && (
                  <section className="bg-slate-50 py-4 px-6 rounded-lg ">
                    <h6 className="mb-2">Target</h6>
                    {location.state.target_preview.lang_ids?.length > 0 && (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">Languages :</label>{" "}
                      </div>
                    )}
                    {Array.isArray(location.state.target_preview.lang_ids) &&
                      location.state.target_preview.lang_ids.length > 0 &&
                      location.state.target_preview.lang_ids.map((item, i) => {
                        return item;
                      })}
                      {(Array.isArray(location.state.target_preview?.zone_ids) && location.state.target_preview?.zone_ids?.length > 0) && <div>
                      {<label className="text-slate-500">Zones : </label>}
                      <b>{location.state.target_preview?.zone_ids?.map((item) => {
                          return item
                      }
                      )}</b>
                      </div>}
                      {!location.state.target_preview?.zone_ids?.length ? <>
                    {Array.isArray(location.state.target_preview.state_ids) &&
                      location.state.target_preview.state_ids.length > 0 && (
                        <div>
                          <label className="text-slate-500">States : </label>
                          {location.state.target_preview.state_ids.map(
                            (item, i) => {
                              return item;
                            }
                          )}
                        </div>
                      )}
                    {Array.isArray(
                      location.state.target_preview.district_ids
                    ) &&
                      location.state.target_preview.district_ids.length > 0 && (
                        <div>
                          {
                            <label className="text-slate-500">
                              Districts :{" "}
                            </label>
                          }
                          {location.state.target_preview.district_ids.map(
                            (item, i) => {
                              return item;
                            }
                          )}
                        </div>
                      )}
                    {Array.isArray(
                      location.state.target_preview.ex_districts
                    ) &&
                      location.state.target_preview.ex_districts.length > 0 && (
                        <div>
                          {
                            <label className="text-slate-500">
                              Excluded Districts :{" "}
                            </label>
                          }
                          {location.state.target_preview.ex_districts.map(
                            (item, i) => {
                              return item;
                            }
                          )}
                        </div>
                      )}
                    {Array.isArray(
                      location.state.target_preview?.constituencies
                    ) &&
                      location.state.target_preview?.constituencies.length >
                        0 && (
                        <div>
                          {location.state.target_preview?.exclude ? (
                            <label className="text-slate-500">
                              Excluded Constituencies :{" "}
                            </label>
                          ) : (
                            <label className="text-slate-500">
                              Constituencies :{" "}
                            </label>
                          )}
                          <b>
                            {" "}
                            {location.state.target_preview.constituencies.map(
                              (item, i) => {
                                return item;
                              }
                            )}
                          </b>
                        </div>
                      )}
                    {Array.isArray(location.state.target_preview.mandal_ids) &&
                      location.state.target_preview.mandal_ids.length > 0 && (
                        <div>
                          {<label className="text-slate-500">Mandals : </label>}
                          {location.state.target_preview.mandal_ids.map(
                            (item, i) => {
                              return item;
                            }
                          )}
                        </div>
                      )}
                    {Array.isArray(location.state.target_preview.ex_mandals) &&
                      location.state.target_preview.ex_mandals.length > 0 && (
                        <div>
                          {
                            <label className="text-slate-500">
                              Excluded Mandals :{" "}
                            </label>
                          }
                          {location.state.target_preview.ex_mandals.map(
                            (item, i) => {
                              return item;
                            }
                          )}
                        </div>
                      )}
                    {Array.isArray(location.state.target_preview.village_ids) &&
                      location.state.target_preview.village_ids.length > 0 && (
                        <div>
                          {
                            <label className="text-slate-500">
                              villages :{" "}
                            </label>
                          }
                          {location.state.target_preview.village_ids.map(
                            (item, i) => {
                              return item;
                            }
                          )}
                        </div>
                      )}
                    {Array.isArray(location.state.target_preview.ex_villages) &&
                      location.state.target_preview.ex_villages.length > 0 && (
                        <div>
                          {
                            <label className="text-slate-500">
                              Excluded villages :{" "}
                            </label>
                          }
                          {location.state.target_preview.ex_villages.map(
                            (item, i) => {
                              return item;
                            }
                          )}
                        </div>
                      )}
                      </> : null}
                    {Array.isArray(location.state.target_preview.app) &&
                      location.state.target_preview.app.length > 0 && (
                        <div>
                          {
                            <label className="text-slate-500">
                              App Category :{" "}
                            </label>
                          }
                          {location.state.target_preview.app.map((item, i) => {
                            return item;
                          })}
                        </div>
                      )}
                    {Array.isArray(location.state.target_preview.minspend) &&
                      location.state.target_preview.minspend.length > 0 && (
                        <div>
                          {
                            <label className="text-slate-500">
                              Minimum Spend :{" "}
                            </label>
                          }
                          {location.state.target_preview.minspend.map(
                            (item, i) => {
                              return item;
                            }
                          )}
                        </div>
                      )}
                    {location.state.target_preview ? (
                      <div>
                        {location.state.target_preview.min_age > 0 && (
                          <p>
                            <label className="text-slate-500">Min Age</label> :{" "}
                            {location.state.target_preview.min_age}
                          </p>
                        )}
                        {location.state.target_preview.max_age > 0 && (
                          <p>
                            <label className="text-slate-500">Max Age</label> :{" "}
                            {location.state.target_preview.max_age}
                          </p>
                        )}
                        {location.state.target_preview.os !== "" && (
                          <p>
                            <label className="text-slate-500">OS</label> :{" "}
                            {location.state.target_preview.os}
                          </p>
                        )}
                        {location.state.target_preview.android_version !== "" && (
                          <p>
                            <label className="text-slate-500">Android Version</label> :{" "}
                            {location.state.target_preview.android_version}
                          </p>
                        )}
                        {location.state.target_preview.ios_version !== "" && (
                          <p>
                            <label className="text-slate-500">IOS Version</label> :{" "}
                            {location.state.target_preview.ios_version}
                          </p>
                        )}
                        {location.state.target_preview.gender !== null && (
                          <p>
                            <label className="text-slate-500">Gender</label> :{" "}
                            {location.state.target_preview.gender}{" "}
                          </p>
                        )}
                      </div>
                    ) : null}
                  </section>
                )}
                {
                  <section className="bg-slate-50 py-4 px-6 rounded-lg">
                    <h6 className="mb-2">Budget</h6>
                    {location.state?.start?.campaign_type === "CPC" && (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">CPC Price : </label>
                        {location.state?.start?.campaign_type === "CPC" &&
                        location.state?.date_budget_preview?.cpc_price > 0 ? (
                          <b>
                            {location.state?.date_budget_preview?.cpc_price}
                          </b>
                        ) : (
                          <b> -</b>
                        )}
                      </div>
                    )}

                    {location.state?.start?.campaign_type === "CPD" && (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">CPD Price : </label>
                        {location.state?.start?.campaign_type === "CPD" &&
                        location.state?.creatselect?.cpd 
                        // || location?.state?.prefillingData?.creatselect?.cpd > 0
                         ? (
                          <b>{location.state?.creatselect?.cpd
                            //  || location?.state?.prefillingData?.creatselect?.cpd
                             }</b>
                        ) : (
                          <>-</>
                        )}
                      </div>
                    )}

                    {location.state?.start?.campaign_type === "CPM" && (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">CPM Price : </label>
                        {location.state?.start?.campaign_type === "CPM" &&
                        location.state?.date_budget_preview?.cpm > 0 ? (
                          <b>{location.state?.date_budget_preview?.cpm}</b>
                        ) : (
                          <b> -</b>
                        )}
                      </div>
                    )}

                    {location.state?.start?.campaign_type !== "CPD" && (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">
                          Daily Budget :{" "}
                        </label>
                        {location.state?.date_budget_preview?.daily_budget >
                        0 ? (
                          <b>
                            {location.state?.date_budget_preview?.daily_budget}
                          </b>
                        ) : (
                          <b> -</b>
                        )}
                      </div>
                    )}

                    {location.state?.start?.campaign_type !== "CPD" && (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">
                          Total Budget :{" "}
                        </label>
                        {location.state?.date_budget_preview?.total_budget >
                        0 ? (
                          <b>
                            {location.state?.date_budget_preview?.total_budget}
                          </b>
                        ) : (
                          <b> -</b>
                        )}
                      </div>
                    )}

                    {location.state?.start?.campaign_type === "CPC" && (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">
                          Daily Click Cap :{" "}
                        </label>
                        {location.state?.start?.campaign_type === "CPC" &&
                        location.state?.date_budget_preview?.daily_click_cap >
                          0 ? (
                          <b>
                            {
                              location.state?.date_budget_preview
                                ?.daily_click_cap
                            }
                          </b>
                        ) : (
                          <b> -</b>
                        )}
                      </div>
                    )}

                    {location.state?.start?.campaign_type === "CPM" && (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">
                          Daily Impression Cap :{" "}
                        </label>
                        {location.state?.start?.campaign_type === "CPM" &&
                        location.state?.date_budget_preview?.daily_imp_cap >
                          0 ? (
                          <b>
                            {location.state?.date_budget_preview?.daily_imp_cap}
                          </b>
                        ) : (
                          <b> -</b>
                        )}
                      </div>
                    )}

                    {location.state?.start?.campaign_type === "CPC" && (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">
                          Total Click Cap :{" "}
                        </label>
                        {location.state?.start?.campaign_type === "CPC" &&
                        location.state?.date_budget_preview?.tot_click_cap >
                          0 ? (
                          <b>
                            {location.state?.date_budget_preview?.tot_click_cap}
                          </b>
                        ) : (
                          <b> -</b>
                        )}
                      </div>
                    )}

                    {location.state?.start?.campaign_type === "CPM" && (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">
                          Total Impression Cap :{" "}
                        </label>
                        {location.state?.start?.campaign_type === "CPM" &&
                        location.state?.date_budget_preview?.tot_imp_cap > 0 ? (
                          <b>
                            {location.state?.date_budget_preview?.tot_imp_cap}
                          </b>
                        ) : (
                          <b> -</b>
                        )}
                      </div>
                    )}
                  </section>
                }
                {
                  <section className="bg-slate-50 py-4 px-6 rounded-lg">
                    <h6 className="mb-2">Date</h6>
                    {!isBrandAd ? (
                      <>
                        {
                          <div className="flex justify-between mb-2">
                            <label className="text-slate-500">
                              Start Date :
                            </label>
                            {(location.state?.start?.campaign_type === "CPD" &&
                              location.state?.date_budget_preview?.start) ||
                            (location.state?.start?.campaign_type !== "CPD" &&
                              location.state?.date_budget_preview
                                ?.start_date) ? (
                              <b>
                                {location.state?.start?.campaign_type === "CPD"
                                  ? DatetoTimestamp(
                                      location.state?.date_budget_preview?.start
                                    )
                                  : DatetoTimestamp(
                                      location.state?.date_budget_preview
                                        ?.start_date
                                    )}
                              </b>
                            ) : (
                              <b> -</b>
                            )}
                          </div>
                        }
                        {
                          <div className="flex justify-between mb-2">
                            <label className="text-slate-500">End Date :</label>
                            {(location.state?.start?.campaign_type === "CPD" &&
                              location.state?.date_budget_preview?.start) ||
                            (location.state?.start?.campaign_type !== "CPD" &&
                              location.state?.date_budget_preview?.end_date) ? (
                              <b>
                                {location.state?.start?.campaign_type !== "CPD"
                                  ? DatetoTimestamp(
                                      location.state?.date_budget_preview
                                        ?.end_date
                                    )
                                  : End_date_cpd(
                                      location.state?.date_budget_preview?.start
                                    )}
                              </b>
                            ) : (
                              <b> -</b>
                            )}
                          </div>
                        }
                      </>
                    ) : (
                      <>
                        {
                          <div className="flex justify-between mb-2">
                            <label className="text-slate-500">
                              Start Date :
                            </label>
                            {location.state?.start?.campaign_type === "CPD" &&
                            location.state?.date_budget_preview?.start_date ? (
                              <b>
                                {DatetoTimestamp(
                                  location.state?.date_budget_preview
                                    ?.start_date
                                )}
                              </b>
                            ) : (
                              <b> -</b>
                            )}
                          </div>
                        }
                        {
                          <div className="flex justify-between mb-2">
                            <label className="text-slate-500">End Date :</label>
                            {location.state?.start?.campaign_type === "CPD" &&
                            location.state?.date_budget_preview?.end_date ? (
                              <b>
                                {DatetoTimestamp(
                                  location.state?.date_budget_preview?.end_date
                                )}
                              </b>
                            ) : (
                              <b> -</b>
                            )}
                          </div>
                        }
                      </>
                    )}
                    {location.state?.start?.campaign_type !== "CPD" &&
                    location.state?.date_budget_preview?.datelist?.length !==
                      0 ? (
                      <div
                        className="flex justify-between mb-2"
                        style={{ display: "block" }}
                      >
                        <label className="text-slate-500">
                          Day Time Slots :
                        </label>
                        {location.state?.date_budget_preview?.datelist
                          ?.length !== 0 ? (
                          <>
                            {location.state?.date_budget_preview?.datelist
                              ?.length > 0
                              ? location.state?.date_budget_preview?.datelist.map(
                                  (item, i) => (
                                    <p key={i}>
                                      {" "}
                                      {DatetoTimestamp(item.sdate)} {<br />}{" "}
                                      {DatetoTimestamp(item.edate)}
                                    </p>
                                  )
                                )
                              : null}
                          </>
                        ) : (
                          <div>None</div>
                        )}
                        {}
                      </div>
                    ) : null}
                    {location.state?.date_budget_preview?.till_date && (
                      <p> Till End Date</p>
                    )}
                  </section>
                }
                <section className="bg-slate-50 py-4 px-6 rounded-lg ">
                  <h6>Create Select</h6>
                  {formik.values.ad_code !== "" && type === "DFP" && (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">Ad Code :</label>{" "}
                      {formik.values.ad_code}
                    </div>
                  )}
                  {formik.values.line_item_code !== null && type === "DFP" && (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">Line Item Code :</label>{" "}
                      {formik.values.line_item_code}
                    </div>
                  )}
                  {formik.values.dfp_creative_ids && type === "DFP" ? (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">
                        DFP Creative Ids :
                      </label>{" "}
                      {formik.values.dfp_creative_ids
                        ?.split(",")
                        ?.map((item) => (
                          <>
                            {item}
                            <br />
                          </>
                        ))}
                    </div>
                  ) : null}
                  {formik.values.post_type !== null && type === "DFP" && (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500"> Post Type :</label>{" "}
                      {formik.values.post_type}
                    </div>
                  )}
                  {formik.values.news_type !== null && type === "DFP" && (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500"> News Type :</label>{" "}
                      {formik.values.news_type}
                    </div>
                  )}
                  {formik.values.dfp_backfill_ad_type && type === "DFP" && (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">
                        {" "}
                        DFP Backfill Ad type :
                      </label>{" "}
                      {
                        dfpBackfillAdTypes.find(
                          (item) =>
                            item.value === formik.values.dfp_backfill_ad_type
                        )?.lable
                      }
                    </div>
                  )}
                  {formik.values.slotuuid && type === "DFP" && (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">Slot Id :</label>{" "}
                      {formik.values.slotuuid}
                    </div>
                  )}
                  {formik.values.banner_size.length &&
                  Array.isArray(formik.values.banner_size) &&
                  type === "DFP" ? (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">Banner Size :</label>{" "}
                      {formik.values.banner_size.join(",")}
                    </div>
                  ) : null}

                  {formik.values.creative_type !== "" && (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">Creative Type :</label>{" "}
                      {formik.values.creative_type}
                    </div>
                  )}
                  {formik.values.frequency_cap > 0 && (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">Frequency :</label>{" "}
                      {formik.values.frequency_cap}
                    </div>
                  )}
                  {formik.values.frequency_cap_type !== "" &&
                    formik.values.positiontype === "rotation" && (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">
                          Frequency Cap Type :
                        </label>{" "}
                        {formik.values.frequency_cap_type}
                      </div>
                    )}
                  <div className="flex justify-between mb-2">
                    <label className="text-slate-500">Position : </label>
                    {formik.values.position}
                  </div>
                  {formik.values.positiontype !== "" && (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">Position Type :</label>{" "}
                      {formik.values.positiontype}
                    </div>
                  )}
                  {formik.values.positiontype === "rotation" &&
                    formik.values.action_type !== null && (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">Action type :</label>{" "}
                        {actiontypeoptions[formik.values.action_type]}
                      </div>
                    )}
                  {localStorage.getItem("role") === roles.ops ||
                  localStorage.getItem("role") === roles.salesperson ? (
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">Priority</label>{" "}
                      {+formik.values.priority}
                    </div>
                  ) : null}
                  {
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">Encryption :</label>{" "}
                      {formik.values.encryption ? "True" : "False"}
                    </div>
                  }
                  {type === "DFP" ?
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">Hidden :</label>{" "}
                      {formik.values.dfp_hidden ? "True" : "False"}
                    </div> : null
                  }
                  {type === "DFP" ?
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">DFP IMA :</label>{" "}
                      {formik.values.dfp_ima ? "True" : "False"}
                    </div> : null
                  }
                  {type === "DFP" ?
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">DFP PGDEAL :</label>{" "}
                      {formik.values.dfp_pgdeal ? "True" : "False"}
                    </div> : null
                  }
                  {type === "DFP" ?
                    <div className="flex justify-between mb-2">
                      <label className="text-slate-500">DFP IMA Obstacle :</label>{" "}
                      {formik.values.dfp_ima_obs ? "True" : "False"}
                    </div> : null
                  }
                </section>
                {location.state.discount_obj && typeofcamp !== "CPD" ? (
                  <section className="bg-slate-50 py-4 px-6 rounded-lg ">
                    <h6>Discount</h6>
                    {location.state.discount_obj.discount_no ? (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">Discount :</label>{" "}
                        {`${location.state.discount_obj.discsign ? "+" : "-"} ${
                          location.state.discount_obj.discount_no
                        } %`}
                      </div>
                    ) : null}
                    {location.state.discount_obj.actualPrice ? (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">Actual Price :</label>{" "}
                        {location.state.discount_obj.actualPrice}
                      </div>
                    ) : null}
                    {location.state.discount_obj.discountPrice ? (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">
                          After Discount :
                        </label>{" "}
                        {location.state.discount_obj.discountPrice}
                      </div>
                    ) : null}
                  </section>
                ) : null}
                {typeofcamp === "CPD" &&
                formik.values.cpd !== tempcpd &&
                tempcpd !== 0 &&
                discoutnEnab ? (
                  <section className="bg-slate-50 py-4 px-6 rounded-lg ">
                    <h6>Discount</h6>
                    {formik.values.cpd ? (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">Discount :</label>{" "}
                        {`${
                          tempcpd - +formik.values.cpd > 0 ? "-" : "+"
                        } ${Math.abs(
                          (100 / tempcpd) * (tempcpd - formik.values.cpd)
                        ).toFixed(2)} %`}
                      </div>
                    ) : null}
                    {tempcpd ? (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">Actual Price :</label>{" "}
                        {tempcpd}
                      </div>
                    ) : null}
                    {formik.values.cpd ? (
                      <div className="flex justify-between mb-2">
                        <label className="text-slate-500">
                          After Discount :
                        </label>{" "}
                        {formik.values.cpd}
                      </div>
                    ) : null}
                  </section>
                ) : null}
              </div>
              {formik.values.creative_ids && (
                <section className="basis-5/12 rounded-2xl overflow-hidden">
                  {
                    <>
                      {" "}
                      {creatives_preview?.length > 0 ? (
                        <Swiper
                          spaceBetween={0}
                          pagination={true}
                          navigation={true}
                          modules={[Navigation, Pagination]}
                          className="mySwiper"
                          style={{ width: "460px" }}
                        >
                          {creatives_preview?.map((campPreview) => (
                            <SwiperSlide>
                              <campCreativeContext4.Provider
                                value={{ campPreview }}
                              >
                                <PreviewFrameEdit showPreview={true} />
                              </campCreativeContext4.Provider>
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      ) : (
                        <section className="preview-mobile">
                          <div className="preview-inner">
                            <div className="preview-full-image">
                              <div className="mt-60 ml-1 preview-text">
                                Preview of your creative will be shown here once
                                after you select your creative
                              </div>
                            </div>
                          </div>
                        </section>
                      )}{" "}
                    </>
                  }
                </section>
              )}
            </section>
          </div>
          <div>
            <form onSubmit={formik.handleSubmit} className="contents">
              <Stepper steps={steps} activeStep={3} />
              <fieldset>
                <legend>Creative Selection</legend>

                <section>
                  {type !== "DFP" && (
                    <div className=" d-flex mb-3 gap-5">
                      <div className="w-full">
                        <label htmlFor="" className="form-label">
                          Creative Type
                        </label>
                        <span className="text-red-600">*</span>
                        <select
                          onBlur={formik.handleBlur}
                          onChange={(e) => {
                            formik.handleChange(e);
                            formik.setFieldValue("cpd", 0);
                            setTempcpd(0);
                          }}
                          value={formik.values.creative_type}
                          name="creative_type"
                          className="form-select"
                          // disabled={location?.state?.status === 2}
                          aria-label="Default select example"
                        >
                          <option value="">select creative type</option>
                          {!isBrandAd && !isClassified && (
                            <>
                              <option value="full_image">Full Image</option>
                              <option value="gallery">Gallery Image</option>
                              <option value="full_video">Full Video</option>
                              <option value="half_video">Half Video</option>
                              <option value="promoted_video_story">
                                Promoted Video Story
                              </option>
                              <option value="promoted_image_story">
                                Promoted Image Story
                              </option>
                              <option value="promoted_gallery">
                                Promoted Gallery
                              </option>
                              <option value="fullvideo_or_gif">
                                Full Video or GIF
                              </option>
                              <option value="webviewad">Web View Ad</option>
                              <option value="framepost">Frame Post</option>
                              <option value="rec_image">Recommended Image</option>
                              <option value="rec_promoted_story">Recommended Promoted Story</option>
                              <option value="job_listings">Jobs Listings</option>
                              <option value="business_listings">Business Listings</option>
                              <option value="specials">Specials</option>
                            </>
                          )}
                          {typeofcamp !== "CPD" && (
                            <option value="commentad">Comment Ad</option>
                          )}
                          {isBrandAd ?
                            <><option value="brandAd">Brand Ad</option>
                            {magazineCreativeOptions.map(item => <option value={item.value}>{item.label}</option>)}
                            </>
                            : null
                          }
                          {isClassified ? classifiedCreativeOptions.map(item => <option value={item.value}>{item.label}</option>) : null}
                        </select>
                        {formik.errors.creative_type &&
                        formik.touched.creative_type ? (
                          <div className="text-red-600">
                            {formik.errors.creative_type}
                          </div>
                        ) : null}
                      </div>
                      {formik.values.creative_type === "webviewad" &&
                      typeofcamp === "CPD" ? (
                        <div className="w-full">
                          <label htmlFor="" className="form-label">
                            WebView Creative Type
                          </label>
                          <span className="text-red-600">*</span>
                          <select
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                              formik.handleChange(e);
                              formik.setFieldValue("cpd", 0);
                              setTempcpd(0);
                            }}
                            value={formik.values.webview_creative_type}
                            name="webview_creative_type"
                            className="form-select"
                            // disabled={location?.state?.status === 2}
                            aria-label="Default select example"
                          >
                            <option value="">select creative type</option>
                            <option value="full_image">Full Image</option>
                            <option value="gallery">Gallery Image</option>
                            <option value="full_video">Full Video</option>
                            <option value="half_video">Half Video</option>
                            <option value="promoted_video_story">
                              Promoted Video Story
                            </option>
                            <option value="promoted_image_story">
                              Promoted Image Story
                            </option>
                            <option value="promoted_gallery">
                              Promoted Gallery
                            </option>
                            <option value="fullvideo_or_gif">
                              Full Video or GIF
                            </option>
                          </select>
                          {formik.errors.webview_creative_type &&
                          formik.touched.webview_creative_type ? (
                            <div className="text-red-600">
                              {formik.errors.webview_creative_type}
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  )}

                  {type !== "DFP" && (formik.values.creative_type !== 'brandAd') && (
                    <div className="mb-3">
                      <label htmlFor="" className="form-label">
                        Creative
                      </label>
                      <span className="text-red-600">*</span>
                      <Select
                        aria-label="Default select example"
                        name="creative_ids"
                        placeholder="select creative"
                        onBlur={formik.handleBlur}
                        value={getvalues(crelist)}
                        onChange={(selected) => onchange(selected)}
                        options={crelist}
                        isMulti
                      ></Select>
                      {formik.errors.creative_ids &&
                      formik.touched.creative_ids ? (
                        <div className="text-red-600">
                          {formik.errors.creative_ids}
                        </div>
                      ) : null}
                    </div>
                  )}
                  {formik.values.creative_type !== "commentad" &&
                    formik.values.creative_type !== 'brandAd' && (
                      <>
                        {type === "DFP" && (
                          <div>
                            <div>
                              <label htmlFor="" className="form-label">
                                Post Type
                              </label>
                              <span className="text-red-600">*</span>
                              <select
                                className="form-select"
                                aria-label="Default select example"
                                name="post_type"
                                placeholder="select sales_person name"
                                value={formik.values.post_type}
                                onBlur={formik.handleBlur}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  setPtype(e.target.value);
                                }}
                              >
                                <option value="" selected>
                                  Select Post Type
                                </option>
                                <option value="full_img_ad">
                                  Full Image Ad
                                </option>
                                <option value="video_webview_ad">
                                  Video Web View Ad
                                </option>
                              </select>
                              {formik.errors.post_type &&
                              formik.touched.post_type ? (
                                <div className="text-red-600">
                                  {formik.errors.post_type}
                                </div>
                              ) : null}
                            </div>
                            {formik.values.post_type === "video_webview_ad" ? (
                              <div>
                                <label htmlFor="" className="form-label">
                                  News Type
                                </label>
                                <span className="text-red-600">*</span>
                                <select
                                  className="form-select"
                                  aria-label="Default select example"
                                  name="news_type"
                                  placeholder="select News type"
                                  value={formik.values.news_type}
                                  onBlur={formik.handleBlur}
                                  onChange={formik.handleChange}
                                >
                                  <option value="" selected>
                                    Select News Type
                                  </option>
                                  <option value="video_ad">Video Ad</option>
                                  <option value="promote_ad">Promote Ad</option>
                                  <option value="webview_ad">
                                    Web View Ad
                                  </option>
                                </select>{" "}
                              </div>
                            ) : null}
                            {formik.errors.news_type &&
                            formik.touched.news_type ? (
                              <div className="text-red-600">
                                {formik.errors.news_type}
                              </div>
                            ) : null}
                          </div>
                        )}
                        {formik.values.post_type === "webview_ad" ? (
                          <div>
                            <label htmlFor="" className="form-label">
                              Iframe Code
                            </label>
                            <span className="text-red-600">*</span>
                            <textarea
                              type="text"
                              className="form-control"
                              name="ad_code"
                              placeholder="enter the <iframe> code"
                              onBlur={formik.handleBlur}
                              value={formik.values.ad_code}
                              onChange={formik.handleChange}
                            />
                            {formik.errors.ad_code && formik.touched.ad_code ? (
                              <div className="text-red-600">
                                {formik.errors.ad_code}
                              </div>
                            ) : null}
                          </div>
                        ) : null}

                        {type === "DFP" ? (
                          <div className="mt-3">
                            {formik.values.post_type !== "webview_ad" && (
                              <div>
                                <label htmlFor="" className="form-label">
                                  Creative Code{" "}
                                </label>
                                <span className="text-red-600">*</span>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="ad_code"
                                  placeholder="enter the code"
                                  onBlur={formik.handleBlur}
                                  value={formik.values.ad_code}
                                  onChange={formik.handleChange}
                                />
                                {formik.errors.ad_code &&
                                formik.touched.ad_code ? (
                                  <div className="text-red-600">
                                    {formik.errors.ad_code}
                                  </div>
                                ) : null}
                              </div>
                            )}
                            <div className="mt-3">
                              <label htmlFor="" className="form-label">
                                Line Item code{" "}
                              </label>
                              <span className="text-red-600">*</span>
                              <input
                                type="text"
                                className="form-control"
                                name="line_item_code"
                                placeholder="enter the code"
                                onBlur={formik.handleBlur}
                                value={formik.values.line_item_code}
                                onChange={formik.handleChange}
                                disabled={location?.state?.status === 2}
                              />
                              {formik.errors.line_item_code &&
                              formik.touched.line_item_code ? (
                                <div className="text-red-600">
                                  {formik.errors.line_item_code}
                                </div>
                              ) : null}
                            </div>
                            <div className="mt-3">
                              <label htmlFor="" className="form-label">
                                DFP Creative ids
                              </label>
                              <span className="text-red-600">*</span>
                              <input
                                type="text"
                                className="form-control"
                                name="dfp_creative_ids"
                                placeholder="Enter 12 digit creative ids"
                                onBlur={formik.handleBlur}
                                value={formik.values.dfp_creative_ids}
                                onChange={formik.handleChange}
                              />
                              {formik.errors.dfp_creative_ids &&
                              formik.touched.dfp_creative_ids ? (
                                <div className="text-red-600">
                                  {formik.errors.dfp_creative_ids}
                                </div>
                              ) : null}
                            </div>
                            <div>
                              <label htmlFor="" className="form-label mt-3">
                                Backfill Ad Type
                              </label>
                              <select
                                className="form-select"
                                aria-label="Default select example"
                                name="dfp_backfill_ad_type"
                                placeholder="select Backfill Ad type"
                                value={formik.values.dfp_backfill_ad_type}
                                onBlur={formik.handleBlur}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  if (
                                    e.target.value !== "dfp_gm_amz" &&
                                    e.target.value !== "dfp_gm_amz_nmb" &&
                                    e.target.value !== "dfp_gm_amz_nmb1"
                                  ) {
                                    formik.setFieldValue("slotuuid", "");
                                  }
                                  formik.setFieldValue("banner_size", []);
                                  formik.setFieldValue("design_type", 0);
                                  formik.setFieldValue("full_scr_type", 0);
                                }}
                              >
                                <option value="" selected>
                                  Select Type
                                </option>
                                {/* <option value="dfp_gm_nmb">GAM-Nimbus</option> */}
                                <option value="dfp_gm_amz">GAM-Amazon</option>
                                {/* <option value="dfp_gm_amz_nmb">
                                  GAM-Amazon-Nimbus
                                </option> */}
                                {/* <option value="dfp_gm_amz_nmb1">
                                  GAM-Amazon+Nimbus
                                </option> */}
                                <option value="dfp_nativebanner">
                                  Native-Banner
                                </option>
                              </select>
                              {formik.errors.dfp_backfill_ad_type &&
                              formik.touched.dfp_backfill_ad_type ? (
                                <div className="text-red-600">
                                  {formik.errors.dfp_backfill_ad_type}
                                </div>
                              ) : null}
                            </div>
                           {formik.values.dfp_backfill_ad_type && <div>
                              <label htmlFor="" className="form-label mt-3">
                                Backfill Design Type
                              </label>
                              <Select
                                className=""
                                aria-label="Default select example"
                                name="design_type"
                                placeholder="select"
                                onBlur={formik.handleBlur}
                                value={[{label: 'Select', value: 0},...DESIGN_OPTIONS].find(i => i.value === formik.values.design_type)}
                                onChange={(selected) =>
                                  {
                                    formik.setFieldValue('design_type', selected.value)
                                    formik.setFieldValue('full_scr_type', 0)
                                  }
                                }
                                options={[{label: 'Select', value: 0},...DESIGN_OPTIONS]}
                              />
                              {formik.errors.design_type &&
                              formik.touched.design_type ? (
                                <div className="text-red-600">
                                  {formik.errors.design_type}
                                </div>
                              ) : null}
                            </div>}
                            {formik.values.design_type === 5 && <div>
                              <label htmlFor="" className="form-label mt-3">
                                Backfill Full Screen Type
                              </label>
                              <Select
                                className=""
                                aria-label="Default select example"
                                name="full_scr_type"
                                placeholder="select"
                                onBlur={formik.handleBlur}
                                value={FULLSCRTYPE_OPTIONS.find(i => i.value === formik.values.full_scr_type)}
                                onChange={(selected) =>
                                  formik.setFieldValue('full_scr_type', selected.value)
                                }
                                options={FULLSCRTYPE_OPTIONS}
                              />
                              {formik.errors.full_scr_type &&
                              formik.touched.full_scr_type ? (
                                <div className="text-red-600">
                                  {formik.errors.full_scr_type}
                                </div>
                              ) : null}
                            </div>}
                            {formik.values.dfp_backfill_ad_type ===
                              "dfp_gm_amz" ||
                            formik.values.dfp_backfill_ad_type ===
                              "dfp_gm_amz_nmb" ||
                            formik.values.dfp_backfill_ad_type ===
                              "dfp_gm_amz_nmb1" ? (
                              <div className="mt-3">
                                <label htmlFor="" className="form-label">
                                  Slot Id
                                </label>
                                <span className="text-red-600">*</span>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="slotuuid"
                                  placeholder="Enter the Slot Id"
                                  onBlur={formik.handleBlur}
                                  value={formik.values.slotuuid}
                                  onChange={formik.handleChange}
                                />
                                {formik.errors.slotuuid &&
                                formik.touched.slotuuid ? (
                                  <div className="text-red-600">
                                    {formik.errors.slotuuid}
                                  </div>
                                ) : null}
                              </div>
                            ) : null}
                            {formik.values.dfp_backfill_ad_type ===
                              "dfp_gm_nmb" ||
                            formik.values.dfp_backfill_ad_type ===
                              "dfp_gm_amz" ||
                            formik.values.dfp_backfill_ad_type ===
                              "dfp_gm_amz_nmb" ||
                            formik.values.dfp_backfill_ad_type ===
                              "dfp_gm_amz_nmb1" ||
                            formik.values.dfp_backfill_ad_type ===
                              "dfp_nativebanner" ? (
                              <div>
                                <label htmlFor="" className="form-label mt-3">
                                  Banner Size
                                </label>
                                <Select
                                  aria-label="Default select example"
                                  name="banner_size"
                                  placeholder="select  Backfill Ad type"
                                  value={bannerOptions.filter(
                                    (option) =>
                                      formik.values.banner_size.indexOf(
                                        option.value
                                      ) >= 0
                                  )}
                                  onBlur={formik.handleBlur}
                                  onChange={(selected) =>
                                    onBannerChange(selected)
                                  }
                                  options={
                                    formik.values.dfp_backfill_ad_type ===
                                    "dfp_nativebanner"
                                      ? bannerOptions
                                      : bannerOptions.filter(
                                          (item) => item.value !== "native"
                                        )
                                  }
                                  isMulti
                                />

                                {/* <select
                       className="form-select"
                       aria-label="Default select example"
                       name="banner_size"
                       placeholder='select  Backfill Ad type'
                       value={formik.values.banner_size}
                       onBlur={formik.handleBlur}
                       onChange={formik.handleChange}
                       >
                       <option value="" selected>Select Banner Size</option>
                       <option value="300x250">300x250</option>
                       <option value="300x600">300x600</option>
                       <option value="320x480">320x480</option>
                     </select>  */}
                                {formik.errors.banner_size &&
                                formik.touched.banner_size ? (
                                  <div className="text-red-600">
                                    {formik.errors.banner_size}
                                  </div>
                                ) : null}
                              </div>
                            ) : null}
                          </div>
                        ) : null}
                      </>
                    )}
                  <div className="row mb-3 align-items-start">
                    {formik.values.creative_type !== "commentad" &&
                      formik.values.creative_type !== 'brandAd' &&
                      !classifiedCreatives.includes(formik.values.creative_type) && (
                        <>
                          {type !== "DFP" && false && (
                            <div className="col-5 relative mb-3 mt-3">
                              <label htmlFor="" className="form-label">
                                Position Type
                              </label>
                              <span className="text-red-600">*</span>
                              <select
                                className="form-select"
                                aria-label="Default select example"
                                onBlur={formik.handleBlur}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                }}
                                value={formik.values.positiontype}
                                name="positiontype"
                              >
                                <option selected value="">
                                  Select Option
                                </option>
                                <option value="fixed">Fixed</option>
                                <option value="rotation">Rotation</option>
                              </select>
                              {formik.errors.positiontype &&
                              formik.touched.positiontype ? (
                                <div className="text-red-600 error_msg">
                                  {formik.errors.positiontype}
                                </div>
                              ) : null}
                            </div>
                          )}

                          <div className="col-5 relative mb-3 mt-3 d-flex align-items-start justify-start gap-3">
                            {!formik.values.sov ? (
                              <div>
                                <label htmlFor="" className="form-label">
                                  Position
                                </label>
                                <span className="text-red-600">*</span>
                                <input
                                  type="number"
                                  className="form-control"
                                  id=""
                                  placeholder="Enter position"
                                  onBlur={formik.handleBlur}
                                  onChange={(e) => {
                                    setDiscountMessage("");
                                    formik.handleChange(e);
                                    if (type !== "DFP" && +e.target.value >= 0 && (!isBrandAd)) {
                                      if(typeofcamp === 'CPD')
                                        setPriceFetchLoading(true);
                                      debouncedHandleLocal(
                                        e.target.value,
                                        formik.values.creative_type !==
                                          "webviewad"
                                          ? formik.values.creative_type
                                          : formik.values
                                              .webview_creative_type
                                      );
                                    }
                                  }}
                                  value={formik.values.position}
                                  name="position"
                                  disabled={location?.state?.status === 2 && !magazineCreatives.includes(formik.values.creative_type)}
                                />
                                {formik.errors.position &&
                                formik.touched.position ? (
                                  <div className="text-red-600 error_msg relative">
                                    {formik.errors.position}
                                  </div>
                                ) : null}
                              </div>
                            ) : null}
                            {typeofcamp === "CPD" && type !== "DFP" && !isBrandAd ? (
                              <div className="d-flex gap-2 mt-auto">
                                <input
                                  type="checkbox"
                                  id="sov"
                                  name="sov"
                                  checked={formik.values.sov}
                                  onBlur={formik.handleBlur}
                                  onChange={(e) => {
                                    setDiscountMessage("");
                                    formik.handleChange(e);
                                    if (e.target.checked) {
                                      formik.setFieldValue("position", 0);
                                    }
                                    if (
                                      type !== "DFP" &&
                                      e.target.checked === true &&
                                      !isBrandAd
                                    )
                                      debounce(
                                        handleLocal(
                                          "sov",
                                          formik.values.creative_type !==
                                            "webviewad"
                                            ? formik.values.creative_type
                                            : formik.values
                                                .webview_creative_type
                                        ),
                                        5000
                                      );
                                    if (
                                      type !== "DFP" &&
                                      e.target.checked === false &&
                                      !isBrandAd
                                    )
                                      debounce(
                                        handleLocal(
                                          0,
                                          formik.values.creative_type !==
                                            "webviewad"
                                            ? formik.values.creative_type
                                            : formik.values
                                                .webview_creative_type
                                        ),
                                        5000
                                      );
                                  }}
                                  disabled={location?.state?.status === 2}
                                />
                                <label htmlFor="sov">SOV</label>
                              </div>
                            ) : null}
                          </div>
                        </>
                      )}
                    {/* <div className="col-2 align-self-end mb-3">
                    <button type="button" className="btn btn-primary" onClick={handleGet}>Get</button>
                  </div> */}
                    {typeofcamp === "CPD" ? (
                      <div className="row mb-3 mt-3">
                        {!isBrandAd && type !== "DFP" ? (
                          <>
                            {" "}
                            <div className="d-flex mt-1 gap-2 items-center">
                              <input
                                type="checkbox"
                                id="EnableDiscount"
                                checked={discoutnEnab}
                                onChange={() => {
                                  setDiscountEnab(!discoutnEnab);
                                  if (!discoutnEnab === false) {
                                    formik.setFieldValue("cpd", tempcpd);
                                  }
                                }}
                                disabled={location?.state?.status === 2}
                              />
                              <label htmlFor="EnableDiscount">
                                Enable Discount %
                              </label>
                            </div>
                            {discoutnEnab &&
                            formik.values.cpd !== "" &&
                            !priceErr ? (
                              <div>
                                Discount given{" "}
                                {tempcpd - formik.values.cpd > 0
                                  ? "(-)"
                                  : "(+)"}{" "}
                                {Math.abs(
                                  (100 / tempcpd) *
                                    (tempcpd - formik.values.cpd)
                                ).toFixed(2)}
                                %
                              </div>
                            ) : null}
                            <div className="col-12">
                              <label htmlFor="" className="form-label mt-3">
                                CPD Price
                              </label>
                              <span className="text-red-600">*</span>
                              <input
                                type="number"
                                className="form-control"
                                placeholder="CPD Price"
                                aria-label=""
                                name="cpd"
                                value={tempcpd}
                                onBlur={formik.handleBlur}
                                readOnly={true}
                              />
                              {!discoutnEnab &&
                              (!isBrandAd) &&
                              formik.errors.cpd &&
                              formik.touched.cpd ? (
                                <div className="text-red-600">
                                  {formik.errors.cpd}
                                </div>
                              ) : null}
                              {priceErr ? (
                                <div className="text-red-600">
                                  {priceErr}{" "}
                                </div>
                              ) : null}
                            </div>
                          </>
                        ) : null}
                      {(descReason || formik.values.fileUrl || formik.values.description) ? (
                        <div className="mt-3">
                          <div className="mb-3">
                          <div>
                          <label htmlFor="fileUrl" className="form-label font-medium d-flex items-end">
                                Description File:
                                <span
                                  className="ml-2 align-middle group relative"
                                  style={{ cursor: "pointer", display: "inline-block" }}
                                  tabIndex={0}
                                  onMouseEnter={(e) => {
                                    const tooltip = e.currentTarget.querySelector('.desc-tooltip');
                                    if (tooltip) {
                                      tooltip.style.setProperty('opacity', '1', 'important');
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    const tooltip = e.currentTarget.querySelector('.desc-tooltip');
                                    if (tooltip) {
                                      tooltip.style.setProperty('opacity', '0', 'important');
                                    }
                                  }}
                                  onFocus={(e) => {
                                    const tooltip = e.currentTarget.querySelector('.desc-tooltip');
                                    if (tooltip) {
                                      tooltip.style.setProperty('opacity', '1', 'important');
                                    }
                                  }}
                                  onBlur={(e) => {
                                    const tooltip = e.currentTarget.querySelector('.desc-tooltip');
                                    if (tooltip) {
                                      tooltip.style.setProperty('opacity', '0', 'important');
                                    }
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    viewBox="0 0 16 16"
                                    className="inline-block text-gray-400"
                                  >
                                    <circle cx="8" cy="8" r="8" />
                                    <text x="8" y="12" textAnchor="middle" fontSize="10" fill="#fff">i</text>
                                  </svg>
                                  <span className="desc-tooltip absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-64 rounded bg-gray-800 text-white text-xs px-3 py-2 opacity-0 transition-opacity duration-200 pointer-events-none whitespace-normal">
                                    Selected locations values doesn't match with package value
                                  </span>
                                </span>
                              </label>
                            </div>
                            <input
                              type="file"
                              id="fileUrl"
                              name="fileUrl"
                              onChange={handleFileChange}
                              onBlur={formik.handleBlur}
                              className="form-control"
                              // disabled={location?.state?.status === 2}
                            />
                            {formik.values.fileUrl && (
                              <p className="text-sm text-gray-800 mt-1">{formik.values.fileUrl}</p>
                            )}
                            {formik.errors.fileUrl && (
                              <span className="text-red-500 text-xs mt-1">{formik.errors.fileUrl}</span>
                            )}
                          </div>
                          <div className="mb-3">
                            <div>
                              <label htmlFor="description" className="block text-sm font-medium text-gray-700">
                                Reason:
                              </label>
                            </div>
                            <textarea
                              id="description"
                              name="description"
                              placeholder="Enter description here"
                              value={formik.values.description}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className="form-control"
                              // disabled={location?.state?.status === 2}
                            />
                            {formik.errors.description && (
                              <span className="text-red-500 text-xs mt-1">{formik.errors.description}</span>
                            )}
                          </div>
                        </div>
                      ) : null}
                        {discoutnEnab || (isBrandAd) || type === "DFP" ? (
                          <div className="col-12 mt-3">
                            <label htmlFor="" className="form-label">
                              {isBrandAd || type === "DFP"
                                ? "CPD Price"
                                : "Discount CPD Price"}
                            </label>
                            <span className="text-red-600">*</span>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="CPD Price"
                              aria-label=""
                              name="cpd"
                              value={formik.values.cpd}
                              onBlur={formik.handleBlur}
                              onChange={formik.handleChange}
                              readOnly={
                                (!isBrandAd &&
                                  !discoutnEnab &&
                                  type !== "DFP") ||
                                priceErr
                              }
                              disabled={location?.state?.status === 2}
                            />
                            {formik.errors.cpd && formik.touched.cpd ? (
                              <div className="text-red-600">
                                {formik.errors.cpd}
                              </div>
                            ) : null}
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                  {formik.values.creative_type !== "commentad" &&
                    (!isBrandAd) && (
                      <>
                        {type !== "DFP" &&
                          formik.values.positiontype === "rotation" && (
                            <div className="row mb-3 align-items-start extraRoom">
                              <div className="col-6">
                                <label htmlFor="" className="form-label">
                                  Set User Frequency
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id=""
                                  placeholder="Frequency"
                                  onBlur={formik.handleBlur}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    Setfct(e.target.value);
                                    if (e.target.value === "") {
                                      formik.setFieldValue("frequency_cap", 0);
                                    }
                                  }}
                                  value={formik.values.frequency_cap}
                                  name="frequency_cap"
                                />
                                {formik.errors.frequency_cap &&
                                formik.touched.frequency_cap ? (
                                  <div className="text-red-600">
                                    {formik.errors.frequency_cap}
                                  </div>
                                ) : null}
                              </div>

                              <div className="col-6">
                                <label htmlFor="" className="form-label">
                                  Frequency Cap Type
                                </label>
                                <select
                                  className="form-select"
                                  aria-label="Default select example"
                                  onBlur={formik.handleBlur}
                                  onChange={formik.handleChange}
                                  value={formik.values.frequency_cap_type}
                                  name="frequency_cap_type"
                                >
                                  <option selected value="">
                                    Select Option
                                  </option>
                                  <option value="day">Day</option>
                                  <option value="week">Week</option>
                                  <option value="month">Month</option>
                                </select>
                                {formik.errors.frequency_cap_type &&
                                formik.touched.frequency_cap_type ? (
                                  <div className="text-red-600">
                                    {formik.errors.frequency_cap_type}
                                  </div>
                                ) : null}

                                <div className="fullWidthRow">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    value={0}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    name="action_type"
                                    id="check"
                                    checked={formik.values.action_type === "0"}
                                  />
                                  <label htmlFor="check" className="form-label">
                                    Shuffle
                                  </label>
                                  <br />
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    value={1}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    id="check11"
                                    name="action_type"
                                    checked={formik.values.action_type === "1"}
                                  />
                                  <label
                                    htmlFor="check11"
                                    className="form-label"
                                  >
                                    Round robin
                                  </label>
                                </div>
                              </div>
                            </div>
                          )}
                        {type !== "DFP" &&
                          formik.values.positiontype === "fixed" &&
                          false && (
                            <div className="col-5">
                              <label htmlFor="" className="form-label">
                                Priority
                              </label>
                              <span className="text-red-600">*</span>
                              <select
                                className="form-select"
                                aria-label="Default select example"
                                onBlur={formik.handleBlur}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                }}
                                value={formik.values.priority}
                                name="priority"
                              >
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                              </select>
                              {formik.errors.priority &&
                              formik.touched.priority ? (
                                <div className="text-red-600">
                                  {formik.errors.priority}
                                </div>
                              ) : null}
                            </div>
                          )}
                      </>
                    )}
                  {
                    /////////////////New Discount ////////////////
                    typeofcamp === "CPD" &&
                    (!isBrandAd) &&
                    formik.values.position &&
                    tempcpd ? (
                      <div className="row mb-3 align-items-start extraRoom"></div>
                    ) : null
                  }
                  {formik.values.creative_type === 'brandAd' || (formik.values.creative_ids?.length && magazineCreatives.includes(formik.values.creative_type) || formik.values.creative_type === 'commentad') ? (  
                    <>
                      <div className="mt-3">
                        <label htmlFor="" className="form-label">
                          Post Ids
                        </label>
                        <span className="text-red-600">*</span>
                        <input
                          type="text"
                          className="form-control"
                          name="brand_post_ids"
                          placeholder="Enter Post Ids"
                          onBlur={formik.handleBlur}
                          value={formik.values.brand_post_ids}
                          onChange={(e) => {
                            if(formik.values.creative_type === 'commentad'){
                              formik.setFieldValue("brand_post_ids", e.target.value);
                              return;
                            }
                            const handleBrandAdsPreview = debounce(
                              () => brandAdsPreview(e.target.value),
                              1000
                            );
                            handleBrandAdsPreview();
                            formik.handleChange(e);
                          }}
                        />
                        {formik.errors.brand_post_ids &&
                        formik.touched.brand_post_ids ? (
                          <div className="text-red-600">
                            {formik.errors.brand_post_ids}
                          </div>
                        ) : null}
                      </div>
                    </>
                  ) : null}

                  {/* {type !== "DFP" && formik.values.creative_type !== "brandAd" ? (
                    <div className="d-flex gap-2">
                      <input
                        type="checkbox"
                        aria-label=""
                        name="encryption"
                        id="encryption"
                        checked={formik.values.encryption}
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        disabled={location?.state?.status === 2}
                      />
                      <div>
                        <label htmlFor="encryption">Url Encryption</label>
                        <span className="text-red-600">*</span>
                      </div>
                      {formik.errors.encryption && formik.touched.encryption ? (
                        <div className="text-red-600">
                          {formik.errors.encryption}
                        </div>
                      ) : null}
                    </div>
                  ) : null} */}
                  {type === "DFP" ? (
                    <div className="d-flex gap-2">
                      <input
                        type="checkbox"
                        aria-label=""
                        name="dfp_hidden"
                        id="dfp_hidden"
                        checked={formik.values.dfp_hidden}
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                      />
                      <div>
                        <label htmlFor="dfp_hidden">Hidden</label>
                        <span className="text-red-600">*</span>
                      </div>
                      {formik.errors.dfp_hidden && formik.touched.dfp_hidden ? (
                        <div className="text-red-600">
                          {formik.errors.dfp_hidden}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  {type === "DFP" ? (
                    <div className="d-flex gap-2">
                      <input
                        type="checkbox"
                        aria-label=""
                        name="dfp_ima"
                        id="dfp_ima"
                        checked={formik.values.dfp_ima}
                        onBlur={formik.handleBlur}
                        onChange={(e) => {formik.handleChange(e); formik.setFieldValue("dfp_ima_obs", false)}}
                      />
                      <div>
                        <label htmlFor="dfp_ima">DFP IMA</label>
                        <span className="text-red-600">*</span>
                      </div>
                      {formik.errors.dfp_ima && formik.touched.dfp_ima ? (
                        <div className="text-red-600">
                          {formik.errors.dfp_ima}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  {type === "DFP" && formik.values.dfp_ima ? (
                    <div className="d-flex gap-2">
                      <input
                        type="checkbox"
                        aria-label=""
                        name="dfp_ima_obs"
                        id="dfp_ima_obs"
                        checked={formik.values.dfp_ima_obs}
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                      />
                      <div>
                        <label htmlFor="dfp_ima_obs">DFP IMA Obstacle</label>
                        <span className="text-red-600">*</span>
                      </div>
                      {formik.errors.dfp_ima_obs && formik.touched.dfp_ima_obs ? (
                        <div className="text-red-600">
                          {formik.errors.dfp_ima_obs}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                {type === "DFP" ? (
                    <div className="d-flex gap-2">
                      <input
                        type="checkbox"
                        aria-label=""
                        name="dfp_pgdeal"
                        id="dfp_pgdeal"
                        checked={formik.values.dfp_pgdeal}
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                      />
                      <div>
                        <label htmlFor="dfp_pgdeal">DFP PGDEAL</label>
                        <span className="text-red-600">*</span>
                      </div>
                      {formik.errors.dfp_pgdeal && formik.touched.dfp_pgdeal ? (
                        <div className="text-red-600">
                          {formik.errors.dfp_pgdeal}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  {!isBrandAd && type !== "DFP" ? (
                    <div className="d-flex gap-2">
                      <input
                        type="checkbox"
                        aria-label=""
                        name="is_backfill"
                        id="is_backfill"
                        checked={formik.values.is_backfill}
                        onBlur={formik.handleBlur}
                        onChange={(e)=>formik.setFieldValue("is_backfill",+e.target.checked)}
                      />
                      <div>
                        <label htmlFor="is_backfill">Is Backfill</label>
                      </div>
                      {formik.errors.is_backfill && formik.touched.is_backfill ? (
                        <div className="text-red-600">
                          {formik.errors.is_backfill}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  {!isBrandAd ? (
                    <div className="d-flex gap-2">
                      <input
                        type="checkbox"
                        aria-label=""
                        name="ad_reach"
                        id="ad_reach"
                        checked={formik.values.ad_reach}
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                      />
                      <div>
                        <label htmlFor="ad_reach">Ad Reach</label>
                        <span className="text-red-600">*</span>
                      </div>
                      {formik.errors.ad_reach && formik.touched.ad_reach ? (
                        <div className="text-red-600">
                          {formik.errors.ad_reach}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  {['webviewad', 'promoted_image_story', 'full_image', 'promoted_video_story'].includes(formik.values.creative_type) ?
                    <div className="d-flex gap-2">
                      <input
                        type="checkbox"
                        aria-label=""
                        name="dir_serve"
                        id="dir_serve"
                        checked={formik.values.dir_serve}
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                      />
                      <div>
                        <label htmlFor="dir_serve">Article Wise Serving</label>
                        <span className="text-red-600">*</span>
                      </div>
                      {formik.errors.dir_serve && formik.touched.dir_serve ? (
                        <div className="text-red-600">
                          {formik.errors.dir_serve}
                        </div>
                      ) : null}
                    </div>
                    : null
                  }
                  {type !== "DFP" ?
                    <div className="d-flex gap-2">
                      <input
                        type="checkbox"
                        aria-label=""
                        name="dir_prmry_serv"
                        id="dir_prmry_serv"
                        checked={formik.values.dir_prmry_serv}
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                      />
                      <div>
                        <label htmlFor="dir_prmry_serv">Serve Primary Impr URL</label>
                        <span className="text-red-600">*</span>
                      </div>
                      {formik.errors.dir_prmry_serv && formik.touched.dir_prmry_serv ? (
                        <div className="text-red-600">
                          {formik.errors.dir_prmry_serv}
                        </div>
                      ) : null}
                    </div>
                    : null
                  }
                  {
                    (formik.values.creative_type === "full_image" || formik.values.post_type === 'full_img_ad' ) && (
                      <div className="d-flex gap-2">
                        <input
                          type="checkbox"
                          aria-label=""
                          name="share_ad"
                          id="share_ad"
                          checked={formik.values.share_ad}
                          onBlur={formik.handleBlur}
                          onChange={(e)=>formik.setFieldValue("share_ad",e.target.checked)}
                        />
                        <div>
                          <label htmlFor="share_ad">Share Ad</label>
                        </div>
                        {formik.errors.share_ad && formik.touched.share_ad ? (
                          <div className="text-red-600">
                            {formik.errors.share_ad}
                          </div>
                        ) : null}
                      </div>)
                  }
                  <div className="d-flex justify-between">
                    <SlButton variant="neutral" onClick={back}>
                      Back
                    </SlButton>
                    <SlButton type="submit" variant="primary" disabled={priceFetchLoading}>
                      Submit
                    </SlButton>
                  </div>
                  <Modal
                    size="sm"
                    show={smShow}
                    onHide={() => {
                      setSmShow(false);
                    }}
                    aria-labelledby="example-modal-sizes-title-sm"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title id="example-modal-sizes-title-sm">
                        LineItem Name
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{campName}</Modal.Body>
                  </Modal>
                </section>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default CreativeSelection;
